export const uploadImageThroughSignedUrl = async (
    uploadUrl: string,
    image: File | Blob,
) => {
    if (!uploadUrl) {
        return;
    }
    const blob =
        image instanceof File ? new Blob([image], { type: image.type }) : image;
    const headers: Record<string, string> = {
        "Content-Type": image.type,
    };
    if (image.size) {
        headers["Content-Length"] = `${image.size}`;
    }
    const uploadResp = await fetch(uploadUrl, {
        method: "PUT",
        mode: "cors",
        headers,
        body: blob,
    });
    if (!uploadResp.ok) {
        throw new Error("Upload failure");
    }
    return uploadResp;
};

export const uploadVideoThroughSignedUrl = async (
    uploadUrl: string,
    video: File,
): Promise<Response | undefined> => {
    if (!uploadUrl) return;

    const blob = new Blob([video], { type: video.type });

    const headers: Record<string, string> = {
        "Content-Type": video.type || "application/octet-stream",
    };
    if (Number.isFinite(video.size) && video.size > 0) {
        headers["Content-Length"] = `${video.size}`;
    }

    const resp = await fetch(uploadUrl, {
        method: "PUT",
        mode: "cors",
        headers,
        body: blob,
    });

    if (!resp.ok) {
        throw new Error("Upload failure");
    }
    return resp;
};
